export default "__VITE_ASSET__CFV5weWS__"